import PropTypes from 'prop-types';

interface IntrospectionType extends PropTypes.Requireable<any> {
  __INTROSPECTION__: boolean;
}

let usesIntrospection: boolean = (PropTypes.any as IntrospectionType)
  .__INTROSPECTION__;

/**
 * @return {boolean}
 */
export const isIntrospectionEnabled = (): boolean => {
  return usesIntrospection;
};

/**
 * Override for testing logic dependent on isIntrospectionEnabled()
 * @param {boolean} newUsesIntrospection
 */
export const setIntrospectionEnabled = (
  newUsesIntrospection: boolean
): void => {
  usesIntrospection = newUsesIntrospection;
};
